export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20modern%20video%20streaming%20app%20interface%20with%20movie%20and%20TV%20show%20thumbnails%2C%20clean%20minimal%20UI%20design%20with%20warm%20amber%20and%20coral%20accent%20colors%2C%20dark%20mode%20elegant%20layout%2C%20high%20quality%20product%20mockup%20on%20a%20light%20warm%20background%2C%20soft%20shadows%2C%20editorial%20photography%20style&width=560&height=560&seq=app-visual-pipi-01&orientation=squarish"
              alt="屁屁影院移动端追剧体验"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line text-sm"></i>
              <span className="whitespace-nowrap">移动追剧</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              随时随地，畅享追剧
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              屁屁影院完美适配手机与平板设备，无需下载安装，打开浏览器即可观看。
              高清流畅播放，支持后台播放与投屏功能，让你随时随地享受追剧乐趣。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg font-medium text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line text-lg"></i>
                App Store
              </button>
              <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg font-medium text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-google-play-line text-lg"></i>
                Google Play
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}